import { getSchemes } from '@/shared/api/schemes';
import { ImageShape } from '@/shared/lib/types';
import { pavilionsData } from '../../configurator/InhouseMap/inhouse-data';
import { sortPavilionRoomsRecord } from './sortPavilionRooms';

export type AppPavilionDataMap = {
    price: number | string;
    space: number;
    image?: ImageShape;
    name: string;
    textSlug: string;
    slug?: string;
    url?: string;
    gallery: {
        img: ImageShape;
    }[];
    size?: string;
    booking?: {
        company: {
            name: string;
            previewLogo?: ImageShape;
            logo?: ImageShape;
            description?: string;
            url?: string;
        };
    };
};

export type AppPavilionsMapResult = {
    data: Record<string, Record<string, AppPavilionDataMap>>;
    images: Record<string, ImageShape | null>;
};

const EMPTY_PAVILIONS_MAP: AppPavilionsMapResult = { data: {}, images: {} };

export default async function getStandsDataMap(slugs: string[], page: number): Promise<AppPavilionsMapResult> {
    try {
        const schemesResponse = await getSchemes({ params: { page } });

        const schemes = schemesResponse.data?.filter((scheme) => slugs.includes(scheme.slug));

        if (schemes && schemes.length > 0) {
            const results = await Promise.all(schemes.map((scheme) => pavilionsData({ schemes: [scheme.id] })));

            const data: Record<string, Record<string, AppPavilionDataMap>> = {};
            const images: Record<string, ImageShape | null> = {};

            schemes.forEach((scheme, index) => {
                data[scheme.slug] = sortPavilionRoomsRecord(scheme.slug, results[index].data || {});
                images[scheme.slug] = scheme.img?.src ? scheme.img : null;
            });

            return { data, images };
        }

        return EMPTY_PAVILIONS_MAP;
    } catch (error: any) {
        console.log(error.message || 'Произошла ошибка при загрузке данных');
        throw error;
    }
}
